import React, { useEffect, useState } from 'react';
import appData from '../data/data';
import ProjectModal from '../components/ProjectModal';
import { FaTh, FaCode, FaBriefcase, FaArrowRight } from 'react-icons/fa';

export default function Projects(){
  const [filter, setFilter] = useState('all');
  const [modalProject, setModalProject] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible');});
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const filteredProjects = filter === 'all' ? appData.projects : appData.projects.filter(p => p.category === filter);

  return (
    <div>
      <section className="section" style={{ paddingTop: '8rem' }}>
        <h1 className="section-title fade-in">Our Projects</h1>
        <p className="section-subtitle fade-in">Explore our portfolio of successful projects across various domains</p>

        <div className="filter-buttons">
          <button className={`filter-btn ${filter==='all'?'active':''}`} onClick={() => setFilter('all')}><FaTh/> All Projects</button>
          <button className={`filter-btn ${filter==='tech'?'active':''}`} onClick={() => setFilter('tech')}><FaCode/> Tech Solutions</button>
          <button className={`filter-btn ${filter==='non-tech'?'active':''}`} onClick={() => setFilter('non-tech')}><FaBriefcase/> Non-Tech Solutions</button>
        </div>

        <div className="card-grid">
          {filteredProjects.map((project, idx) => (
            <div key={idx} className="project-card fade-in" style={{ animationDelay: `${idx*.1}s` }}>
              <div className="project-icon-container"><div className="project-main-icon"><project.Icon/></div></div>
              <div className="project-content">
                <span className="project-category">{project.category === 'tech' ? 'Tech' : 'Non-Tech'}</span>
                <h3 className="project-title">{project.title}</h3>
                <p className="card-description">{project.description}</p>
                <p className="project-tech">{project.tech}</p>
                <button className="btn btn-primary" style={{ marginTop: '1rem', width: '100%', justifyContent: 'center' }} onClick={() => setModalProject(project)}><FaArrowRight/> View Details</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {modalProject && <ProjectModal project={modalProject} onClose={() => setModalProject(null)} />}
    </div>
  );
}
